const autoNgTemplateLoaderTemplate1 = require('./porAccessManagement.html');

export const porAccessManagement = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'porAccessManagementController',
  controllerAs: 'ctrl',
  bindings: {
    accessControlledEntity: '<',
    inheritFrom: '<',
    entityType: '@',
    updateAccess: '<',
    actionInProgress: '<',
    filterUsers: '<',
    limitedFeature: '<',
  },
};
